"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CurrencyDollarIncrease: ['currency-dollar-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 17.248L22.5 12.748 18 12.748', 'M22.5,12.748,17.45,17.8a2.252,2.252,0,0,1-2.237.565L9.5,16.837a2.251,2.251,0,0,0-2.172.583L1.5,23.252', 'M12,5.252H9.967a1.342,1.342,0,0,0-.5,2.587l2.064.825a1.342,1.342,0,0,1-.5,2.588H9', 'M10.5 5.252L10.5 4.502', 'M10.5 12.002L10.5 11.252', 'M17.852,9.737A7.5,7.5,0,1,0,6,14.251']],
  CurrencyDollarDiamond: ['currency-dollar-diamond', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M15.75,9.75v-6H18a1.5,1.5,0,0,1,0,3,1.5,1.5,0,0,1,0,3Z', 'M15.75 6.75L18 6.75', 'M17.25 3.75L17.25 3', 'M17.25 9.75L17.25 10.5', 'M8.25,14.25H6.217a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H5.25', 'M6.75 14.25L6.75 13.5', 'M6.75 21L6.75 20.25', 'M0.750 17.250 A6.000 6.000 0 1 0 12.750 17.250 A6.000 6.000 0 1 0 0.750 17.250 Z', 'M0.75 4.5L3 8.25 6.75 6', 'M8.189.9A6.752,6.752,0,0,0,3.772,7.786', 'M23.25 19.5L21 15.75 17.25 18', 'M15.811,23.1a6.752,6.752,0,0,0,4.417-6.884']],
  CurrencyDollarBreak: ['currency-dollar-break', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.071,8.25H8.859a1.661,1.661,0,0,0-1.788,1.789c0,1.961,6,3.461,6,5.422a1.757,1.757,0,0,1-1.789,1.789H7.071', 'M10.071 8.25L10.071 6', 'M10.071 19.5L10.071 17.25', 'M18.321,13.5l1.5-4.5-3.75-2.25V1.391A11.251,11.251,0,1,0,22.929,15.75Z']],
  CurrencyEuroCircle: ['currency-euro-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 12.000 A10.500 10.500 0 1 0 22.500 12.000 A10.500 10.500 0 1 0 1.500 12.000 Z', 'M13.5,16.5C10.6,16.5,9,14.9,9,12s1.6-4.5,4.5-4.5', 'M7.5 10.5L13.5 10.5', 'M7.5 13.5L12 13.5']],
  CurrencyEuroDollarExchange: ['currency-euro-dollar-exchange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,3.75H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75', 'M17.25 3.75L17.25 3', 'M17.25 10.5L17.25 9.75', 'M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M0.750 17.250 A6.000 6.000 0 1 0 12.750 17.250 A6.000 6.000 0 1 0 0.750 17.250 Z', 'M8.25,20.25a3,3,0,0,1,0-6', 'M4.5 17.25L8.25 17.25', 'M0.75 4.5L3 8.25 6.75 6', 'M8.189.9A6.752,6.752,0,0,0,3.772,7.786', 'M23.25 19.5L21 15.75 17.25 18', 'M15.811,23.1a6.752,6.752,0,0,0,4.417-6.884']],
  CurrencyEuro: ['currency-euro', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,23.25a11.25,11.25,0,0,1,0-22.5', 'M4.5 9.75L16.5 9.75', 'M4.5 14.25L13.5 14.25']],
  CurrencyEuroBubble: ['currency-euro-bubble', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,16.5C10.6,16.5,9,14.9,9,12s1.6-4.5,4.5-4.5', 'M7.5 10.5L13.5 10.5', 'M7.5 13.5L12 13.5', 'M22.5,12a3.5,3.5,0,0,0-2.443-3.337,3.5,3.5,0,0,0-4.72-4.72,3.5,3.5,0,0,0-6.674,0,3.5,3.5,0,0,0-4.72,4.72,3.5,3.5,0,0,0,0,6.674,3.5,3.5,0,0,0,4.72,4.72,3.5,3.5,0,0,0,6.674,0,3.5,3.5,0,0,0,4.72-4.72A3.5,3.5,0,0,0,22.5,12Z']],
  CurrencyEuroIncrease: ['currency-euro-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 17.25L22.5 12.75 18 12.75', 'M22.5,12.75,17.45,17.8a2.249,2.249,0,0,1-2.237.564L9.5,16.839a2.249,2.249,0,0,0-2.172.582L1.5,23.253', 'M12,11.25a3,3,0,0,1,0-6', 'M8.25 8.25L12 8.25', 'M17.852,9.735A7.5,7.5,0,1,0,6,14.25']],
  CurrencyPoundBubble: ['currency-pound-bubble', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a3.5,3.5,0,0,0-2.443-3.337,3.5,3.5,0,0,0-4.72-4.72,3.5,3.5,0,0,0-6.674,0,3.5,3.5,0,0,0-4.72,4.72,3.5,3.5,0,0,0,0,6.674,3.5,3.5,0,0,0,4.72,4.72,3.5,3.5,0,0,0,6.674,0,3.5,3.5,0,0,0,4.72-4.72A3.5,3.5,0,0,0,22.5,12Z', 'M15,8.25a2.25,2.25,0,0,0-4.5,0V15A1.5,1.5,0,0,1,9,16.5h6', 'M9 12L13.5 12']],
  CurrencyPoundDecrease: ['currency-pound-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 18.75L22.5 23.25 18 23.25', 'M22.5,23.25,17.45,18.2a2.252,2.252,0,0,0-2.237-.565L9.5,19.161a2.249,2.249,0,0,1-2.172-.582L1.5,12.746', 'M3.148,9.739A7.5,7.5,0,1,1,15,14.253', 'M12,6A1.5,1.5,0,0,0,9,6V9.75a1.5,1.5,0,0,1-1.5,1.5H12', 'M7.5 8.25L10.5 8.25']],
  CurrencyPound: ['currency-pound', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.625 12.75L17.625 12.75', 'M19.125,6a5.25,5.25,0,0,0-10.5,0V19.5a3.75,3.75,0,0,1-3.75,3.75h14.25']],
  CurrencyYuan: ['currency-yuan', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 11.25L12 23.25', 'M7.5 14.25L16.5 14.25', 'M7.5 17.25L16.5 17.25', 'M7.5.75v6a4.5,4.5,0,0,0,9,0v-6']],
  CurrencyPoundIncrease: ['currency-pound-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 17.248L22.5 12.748 18 12.748', 'M22.5,12.748,17.45,17.8a2.252,2.252,0,0,1-2.237.565L9.5,16.837a2.251,2.251,0,0,0-2.172.583L1.5,23.252', 'M17.852,9.737A7.5,7.5,0,1,0,6,14.251', 'M12,6A1.5,1.5,0,0,0,9,6v3.75a1.5,1.5,0,0,1-1.5,1.5H12', 'M7.5 8.248L10.5 8.248']],
  CurrencyYuanBill: ['currency-yuan-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a4.5,4.5,0,0,0-3-4.243V6A1.5,1.5,0,0,0,18,4.5H6A1.5,1.5,0,0,0,4.5,6V7.757a4.5,4.5,0,0,0,0,8.486V18A1.5,1.5,0,0,0,6,19.5H18A1.5,1.5,0,0,0,19.5,18V16.243A4.5,4.5,0,0,0,22.5,12Z', 'M10.5,9v1.5a1.5,1.5,0,0,0,3,0V9', 'M12 12L12 16.5', 'M10.5 13.5L13.5 13.5']],
  CurrencyYuanBubble: ['currency-yuan-bubble', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a3.5,3.5,0,0,0-2.443-3.337,3.5,3.5,0,0,0-4.72-4.72,3.5,3.5,0,0,0-6.674,0,3.5,3.5,0,0,0-4.72,4.72,3.5,3.5,0,0,0,0,6.674,3.5,3.5,0,0,0,4.72,4.72,3.5,3.5,0,0,0,6.674,0,3.5,3.5,0,0,0,4.72-4.72A3.5,3.5,0,0,0,22.5,12Z', 'M9,7.5V9.75a3,3,0,0,0,6,0V7.5', 'M12 12.75L12 18', 'M9.75 15L14.25 15']],
  CurrencyUserExchange: ['currency-user-exchange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.375 3.375 A2.625 2.625 0 1 0 14.625 3.375 A2.625 2.625 0 1 0 9.375 3.375 Z', 'M7.5,11.25a4.5,4.5,0,0,1,9,0', 'M21,12.75a1.5,1.5,0,0,0-1.5-1.5H4.5A1.5,1.5,0,0,0,3,12.75', 'M3 17.25L3 15.75', 'M3 23.25L3 21.75', 'M4.5,17.25H2.25A.745.745,0,0,0,1.5,18c0,1.5,3,1.5,3,3a.75.75,0,0,1-.75.75H1.5', 'M10.5,15.75v1.5a1.5,1.5,0,0,0,3,0v-1.5', 'M12 18.75L12 23.25', 'M10.5 20.25L13.5 20.25', 'M22.5,17.25a1.5,1.5,0,0,0-3,0v4.5a1.5,1.5,0,0,1-1.5,1.5h4.5', 'M18 20.25L22.5 20.25']],
  CurrencyYuanIncrease: ['currency-yuan-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 17.25L22.5 12.75 18 12.75', 'M22.5,12.75,17.45,17.8a2.249,2.249,0,0,1-2.237.564L9.5,16.839a2.249,2.249,0,0,0-2.172.582L1.5,23.253', 'M9,5.25V6a1.5,1.5,0,0,0,3,0V5.25', 'M10.5 7.5L10.5 11.25', 'M9 9.75L12 9.75', 'M17.852,9.735A7.5,7.5,0,1,0,6,14.25']],
  CurrencyEuroDecrease: ['currency-euro-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 18.752L22.5 23.252 18 23.252', 'M22.5,23.252,17.45,18.2a2.251,2.251,0,0,0-2.237-.564L9.5,19.163a2.251,2.251,0,0,1-2.172-.583L1.5,12.748', 'M12,11.252a3,3,0,0,1,0-6', 'M8.25 8.252L12 8.252', 'M3.148,9.737A7.5,7.5,0,1,1,15,14.252']],
  CurrencyDollarCircle: ['currency-dollar-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 12.000 A10.500 10.500 0 1 0 22.500 12.000 A10.500 10.500 0 1 0 1.500 12.000 Z', 'M15,7.5H10.789A1.662,1.662,0,0,0,9,9.289c0,1.961,6,3.461,6,5.422A1.757,1.757,0,0,1,13.211,16.5H9', 'M12 7.5L12 5.25', 'M12 18.75L12 16.5']],
  CurrencyDollarBubble: ['currency-dollar-bubble', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a3.5,3.5,0,0,0-2.443-3.337,3.5,3.5,0,0,0-4.72-4.72,3.5,3.5,0,0,0-6.674,0,3.5,3.5,0,0,0-4.72,4.72,3.5,3.5,0,0,0,0,6.674,3.5,3.5,0,0,0,4.72,4.72,3.5,3.5,0,0,0,6.674,0,3.5,3.5,0,0,0,4.72-4.72A3.5,3.5,0,0,0,22.5,12Z', 'M15,7.5H10.789A1.662,1.662,0,0,0,9,9.289c0,1.961,6,3.461,6,5.422A1.757,1.757,0,0,1,13.211,16.5H9', 'M12 7.5L12 5.25', 'M12 18.75L12 16.5']],
  CurrencyDollar: ['currency-dollar', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,3.75H10.8a3.3,3.3,0,0,0-3.3,3.3c0,4.95,9,4.95,9,9.9a3.3,3.3,0,0,1-3.3,3.3H7.5', 'M12 3.75L12 0.75', 'M12 20.25L12 23.25']],
  CurrencyDollarBill: ['currency-dollar-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,9H11.467a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H10.5', 'M12 9L12 8.25', 'M12 15.75L12 15', 'M22.5,12a4.5,4.5,0,0,0-3-4.243V6A1.5,1.5,0,0,0,18,4.5H6A1.5,1.5,0,0,0,4.5,6V7.757a4.5,4.5,0,0,0,0,8.486V18A1.5,1.5,0,0,0,6,19.5H18A1.5,1.5,0,0,0,19.5,18V16.243A4.5,4.5,0,0,0,22.5,12Z']],
  CurrencyDollarInternational: ['currency-dollar-international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,3.75h-5.7a3.3,3.3,0,0,0-3.3,3.3c0,4.95,9,4.95,9,9.9a3.3,3.3,0,0,1-3.3,3.3h-5.7', 'M18.75 3.75L18.75 0.75', 'M18.75 20.25L18.75 23.25', 'M12,23.25A11.25,11.25,0,0,1,12,.75', 'M1.398 8.25L11.25 8.25', 'M1.402 15.75L11.25 15.75', 'M12,23.25c-2.9,0-5.25-5.037-5.25-11.25S9.1.75,12,.75']],
  CurrencyEuroInternational: ['currency-euro-international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.25A11.25,11.25,0,0,1,12,.75', 'M1.398 8.25L11.25 8.25', 'M1.402 15.75L9.75 15.75', 'M12,23.25c-2.9,0-5.25-5.037-5.25-11.25S9.1.75,12,.75', 'M23.25,20.25a8.25,8.25,0,0,1,0-16.5', 'M12.75 11.25L20.25 11.25', 'M12.75 14.25L18.75 14.25']],
  CurrencyPoundInternational: ['currency-pound-international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.25A11.25,11.25,0,0,1,12,.75', 'M1.398 8.25L11.25 8.25', 'M1.402 15.75L9.75 15.75', 'M12,23.25c-2.9,0-5.25-5.037-5.25-11.25S9.1.75,12,.75', 'M23.25,20.25H12.75a3,3,0,0,0,3-3V7.5a3.75,3.75,0,0,1,7.5,0', 'M12.75 12.75L21.75 12.75']],
  CurrencyYuanDecrease: ['currency-yuan-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 18.75L22.5 23.25 18 23.25', 'M22.5,23.25,17.45,18.2a2.252,2.252,0,0,0-2.237-.565L9.5,19.161a2.249,2.249,0,0,1-2.172-.582L1.5,12.746', 'M10.5,5.25V6a1.5,1.5,0,0,0,3,0V5.25', 'M12 7.5L12 11.25', 'M10.5 9.75L13.5 9.75', 'M4.648,9.739A7.5,7.5,0,1,1,16.5,14.253']],
  CurrencyPoundBill: ['currency-pound-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a4.5,4.5,0,0,0-3-4.243V6A1.5,1.5,0,0,0,18,4.5H6A1.5,1.5,0,0,0,4.5,6V7.757a4.5,4.5,0,0,0,0,8.486V18A1.5,1.5,0,0,0,6,19.5H18A1.5,1.5,0,0,0,19.5,18V16.243A4.5,4.5,0,0,0,22.5,12Z', 'M13.5,9a1.5,1.5,0,0,0-3,0v4.5A1.5,1.5,0,0,1,9,15h4.5', 'M9 12L13.5 12']],
  CurrencyDollarDecrease: ['currency-dollar-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5 18.75L22.5 23.25 18 23.25', 'M22.5,23.25,17.45,18.2a2.252,2.252,0,0,0-2.237-.565L9.5,19.161a2.249,2.249,0,0,1-2.172-.582L1.5,12.746', 'M3.148,9.739A7.5,7.5,0,1,1,15,14.253', 'M12,5.254H9.967a1.342,1.342,0,0,0-.5,2.587l2.064.825a1.342,1.342,0,0,1-.5,2.588H9', 'M10.5 5.254L10.5 4.504', 'M10.5 12.004L10.5 11.254']],
  CurrencyYuanInternational: ['currency-yuan--international', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.25A11.25,11.25,0,0,1,12,.75', 'M1.398 8.25L11.25 8.25', 'M1.402 15.75L11.25 15.75', 'M12,23.25c-2.9,0-5.25-5.037-5.25-11.25S9.1.75,12,.75', 'M20.25 9.75L20.25 21.75', 'M17.25 12.75L23.25 12.75', 'M17.25 15.75L23.25 15.75', 'M23.25,2.25v4.5a3,3,0,0,1-6,0V2.25']],
  CurrencyEuroBill: ['currency-euro-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,12a4.5,4.5,0,0,0-3-4.243V6A1.5,1.5,0,0,0,18,4.5H6A1.5,1.5,0,0,0,4.5,6V7.757a4.5,4.5,0,0,0,0,8.486V18A1.5,1.5,0,0,0,6,19.5H18A1.5,1.5,0,0,0,19.5,18V16.243A4.5,4.5,0,0,0,22.5,12Z', 'M13.5,15a3,3,0,0,1,0-6', 'M9 12L13.5 12']],
  CurrencyYuanCircle: ['currency-yuan-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 12.000 A10.500 10.500 0 1 0 22.500 12.000 A10.500 10.500 0 1 0 1.500 12.000 Z', 'M9,7.5V9.75a3,3,0,0,0,6,0V7.5', 'M12 12.75L12 18', 'M9.75 15L14.25 15']],
  CurrencyPoundCircle: ['currency-pound-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 12.000 A10.500 10.500 0 1 0 22.500 12.000 A10.500 10.500 0 1 0 1.500 12.000 Z', 'M15,8.25a2.25,2.25,0,0,0-4.5,0V15A1.5,1.5,0,0,1,9,16.5h6', 'M9 12L13.5 12']]
};
exports["default"] = _default;